import axios from "axios";
// const BASE_URL = "http://localhost:5000/";
// const BASE_URL = "https://vpvn-dict.netlify.app";
// const BASE_URL = "https://vpvn-dictionaries.onrender.com";
// const BASE_URL = "https://dictionaries-git-ocm2ii4upa-as.a.run.app";
const BASE_URL = "https://dictapi.khoiphuccuachua.com";
export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
